export default {
    stripeSecret: process.env.VUE_APP_STRIPE_PUBLICKEY,
    plan: {
        'MP' : process.env.VUE_APP_STRIPE_MONTH_PLAN,
        'YP': process.env.VUE_APP_STRIPE_YEAR_PLAN,
        'MB' : process.env.VUE_APP_STRIPE_B_MONTH_PLAN,
        'YB': process.env.VUE_APP_STRIPE_B_YEAR_PLAN
    },
    returnSuccess: process.env.VUE_APP_STRIPE_RETURNSUCCESS_URL,
    returnFailure: process.env.VUE_APP_STRIPE_RETURNFAIL_URL
}